import { IBubbleGrid } from 'js/bubbleCore/types';
import { ILevelData } from 'js/bubbleCore/levelParser/parseLevel';
import { BubbleFactory, regularColors } from 'js/bubbleCore/bubbles/BubbleFactory';
import { fillRowParse } from 'js/bubbleCore/handlers/fillRow';

export function parseGrid(factory: BubbleFactory, levelData: ILevelData): IBubbleGrid {
  const startSpeed = (levelData.grid.rowsToFill < levelData.grid.scrollFill) ?
    levelData.grid.fillScrollSpeed : levelData.grid.scrollSpeed;

  const grid: IBubbleGrid = {
    scrollFill: levelData.grid.scrollFill,
    scrollSpeed: startSpeed,
    normalScrollSpeed: levelData.grid.scrollSpeed,
    fillScrollSpeed: levelData.grid.fillScrollSpeed,
    type: levelData.grid.type,
    asymetrical: levelData.grid.asymetrical,
    limits: levelData.grid.hexLimits,
    offset: {x: 0, y: 0},
    values: {},
    deathLineY: levelData.grid.deathLineY,
  };

  for (let i = 0; i < levelData.grid.rowsToFill; i++) {
    fillRowParse(grid, factory, i, levelData.config.availableColors[0].colors);
  }

  return grid;
};